/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {LabelOutlined, LocalGasStationOutlined, PinOutlined, TwoWheelerOutlined} from '@mui/icons-material'
import {useState} from "react";
import {obtenerPlaca} from "../../Utilidades/obtenerPlaca";
import {collection, orderBy, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

const Formulario_Check_Moto = ({...props}) => {
    const [cargando, setCargando] = useState(false)


    const buscarPlaca = async () => {

        let val = props.props.getValues('placa')
        if (!val){
            return
        }
        let placa = obtenerPlaca(val)

        setCargando(true)
        let q = query(collection(fire, 'listascheckeo'), where('placa', '==', placa), orderBy('fecha', 'desc'))
        let doxs = await obtenerColeccionQuery(q)
        if (doxs.res && doxs.data.length > 0) {
            setearDatos(doxs.data[0])
        }
        setCargando(false)

    }

    const setearDatos = (data) => {

        props.props.setValue('placa', data.placa)
        props.props.setValue('marca', data.marca)
        props.props.setValue('modelo', data.modelo)
        props.props.setValue('cilindraje', data.cilindraje)

    }


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <Typography>Datos de Moto</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTextoBoton
                        click={buscarPlaca}
                        Icono={PinOutlined} nombre={'Placa Moto'} dato={'placa'} {...props}
                        cargando={cargando} requerido={'La Placa Moto es requerida'}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={TwoWheelerOutlined} nombre={'Marca'} dato={'marca'} {...props}
                                  requerido={'La Marca es requerida'}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LabelOutlined} nombre={'Modelo'} dato={'modelo'} {...props}
                                  requerido={'El Modelo es requerido'}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LocalGasStationOutlined} nombre={'Cilindraje'} dato={'cilindraje'} {...props}
                                  requerido={'El Cilindraje es requerido'}/>
                </Grid>

                <Grid container size={12}>
                    <Typography>Lista de Checkeo</Typography>
                </Grid>

                {preguntas.map((it, index) => {
                    return (
                        <Grid container key={`klj5${index}`} size={12} sx={{
                            border: 1,
                            px: 1,
                            py: 0.5,
                            borderColor: props.props.watch(it.dato) ? '#00000050' : 'red',
                            borderRadius: 2
                        }}>
                            <IngresoCheckGrupo nombre={it.nombre} dato={it.dato} {...props}
                                               opciones={['Si', 'No', 'N/A']}
                            />
                        </Grid>
                    )
                })}


                <Grid container size={12}>
                    <IngresoTexto nombre={'Observaciones'} dato={'observaciones'} {...props} lineas={6}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Check_Moto

const preguntas = [
    {
        nombre: 'Matricula vigente',
        dato: 'matricula'
    },
    {
        nombre: 'Licencia tipo A vigente',
        dato: 'licencia'
    },
    {
        nombre: 'Mandos en buen estado y funcionando',
        dato: 'mandos'
    },
    {
        nombre: 'Sistema electronico en buen estado (direccionales, stop, altas-bajas, pito)',
        dato: 'electronico'
    },
    {
        nombre: 'Sistema de frenos en buen estado y sin fugas (pastillas, liquido de frenos)',
        dato: 'frenos'
    },
    {
        nombre: 'Llantas con suficiente labrado y en buen estado',
        dato: 'llantas'
    },
    {
        nombre: 'Motor en buen estado (sin fujas y buen nivel de aceite)',
        dato: 'motor'
    },
    {
        nombre: 'Suspencion sin escape de fluido',
        dato: 'suspencion'
    },
    {
        nombre: 'Luces completa y direccionales funcionando',
        dato: 'luces'
    },
    {
        nombre: 'Espejos en buen estado',
        dato: 'espejos'
    },
    {
        nombre: 'Kit de arraste (cadena engrasada y catalia en buen estado)',
        dato: 'arrastre'
    },
    {
        nombre: 'Asiento como y en buen estado',
        dato: 'asiento'
    },
    {
        nombre: 'Chaleco reflectivo',
        dato: 'chaleco'
    },
    {
        nombre: 'Casco con vicera y seguro (homologado)',
        dato: 'caso'
    },
    {
        nombre: 'Orden y limpieza',
        dato: 'orden'
    },
]
